import type { DashboardSection } from '@/features/dashboard/api/schemas'
import { sectionTakes } from '@/features/dashboard/model/sections'
import { MultiSelectFilter } from './MultiSelectFilter'
import { REGULATORY_FILTERS, useRegulatoryFilters } from './regulatoryFilters'
import styles from './DeepDiveFilters.module.css'

/**
 * The dropdown filters of a deep dive, for the union of those its cards list:
 * C-level, criticality and tag. The market chips are in the sticky header.
 * Renders nothing when no card takes any.
 */
export const DeepDiveFilters = ({ section }: { section: DashboardSection }) => {
  const { selection, toggle } = useRegulatoryFilters()

  const regulatory = REGULATORY_FILTERS.filter(({ filter }) =>
    sectionTakes(section, filter)
  )
  if (regulatory.length === 0) return null

  return (
    <div className={styles.filters}>
      <div className={styles.dropdowns} role='group' aria-label='Filter by'>
        {regulatory.map(({ param, label, options, searchable }) => (
          <MultiSelectFilter
            key={param}
            label={label}
            options={options}
            selected={selection[param]}
            searchable={searchable}
            onToggle={value => toggle(param, value)}
          />
        ))}
      </div>
    </div>
  )
}
